"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _q = _interopRequireDefault(require("q"));

var _underscore = require("underscore");

var _Durations = require("../../../lib/Durations");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var MeetingSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(MeetingSelector, _PureComponent);
  (0, _createClass2.default)(MeetingSelector, null, [{
    key: "propTypes",
    get: function get() {
      return {
        updateDyno: _react.PropTypes.func.isRequired,
        redirectUrl: _react.PropTypes.string
      };
    }
  }]);

  function MeetingSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MeetingSelector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MeetingSelector).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(MeetingSelector, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var value = _ref.target.value;
      this.props.updateDyno({
        redirectUrl: value.options.url
      });
    }
  }, {
    key: "getPages",
    value: function getPages(input, callback) {
      _q.default.Promise.all([_apiClient.default.get('meetings/v1/link/portal', {
        query: {
          limit: 30,
          q: input
        }
      }), _apiClient.default.get('users/v2/app/hub-users', {
        query: {
          hubId: _hubspot.default.get()
        }
      })]).then(function (result) {
        // result is a two element array
        // result[0] is the meetings response, result[1] is users.
        var idToName = {};
        result[1].forEach(function (u) {
          return idToName[u.id] = _I18n.default.formatName(u) || u.email;
        });
        var rawOptions = result[0].map(function (item) {
          var name;

          if (item.name) {
            name = item.name;
          } else if (item.customParams.durations.length) {
            name = (0, _Durations.getReadableDurations)(item.customParams.durations);
          } else {
            name = item.link;
          }

          return {
            userId: item.userId,
            text: name,
            help: item.link,
            options: {
              label: name,
              url: item.link
            },
            value: item.id
          };
        });
        var optionsGrouped = (0, _underscore.groupBy)(rawOptions, function (e) {
          return e.userId;
        });
        var options = [];
        Object.keys(optionsGrouped).forEach(function (userId) {
          options.push({
            text: idToName[userId] || _I18n.default.text('common.meetings.userNotFound'),
            options: optionsGrouped[userId]
          });
        });
        callback(null, {
          options: options
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var url = this.props.redirectUrl;
      var value = null;

      if (url) {
        value = {
          text: url,
          options: {
            label: url,
            url: url
          },
          value: url
        };
      }

      return _react.default.createElement(_UISelect.default, {
        className: "meetings-selector",
        defaultValue: value,
        loadOptions: this.getPages,
        multi: false,
        onSelectedOptionChange: this.handleChange,
        placeholder: _I18n.default.text('common.meetings.placeholder'),
        searchable: true
      });
    }
  }]);
  return MeetingSelector;
}(_react.PureComponent);

exports.default = MeetingSelector;
module.exports = exports.default;